"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactRequest = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../../constants");
const elements_1 = require("../../../elements");
const translate_1 = require("../../../translate");
const create_styles_1 = require("../../../utils/create-styles");
const ContactRequestElement = (0, styled_1.default)(elements_1.Div)(({ isOpened }) => ({
    ...(0, create_styles_1.createStyles)({
        ...(isOpened
            ? {}
            : {
                backgroundColor: constants_1.Color.TRANSPARENT_GREEN,
                borderLeft: `${constants_1.theme.border.width.thick}px solid ${constants_1.Color.DARK_GREEN}`,
            }),
        cursor: 'pointer',
        px: 3.5,
        transition: constants_1.theme.animation.transition,
    }),
    '&:hover': {
        backgroundColor: constants_1.Color.LIGHTEST_BLUE,
    },
    '&:last-child': {
        borderBottomLeftRadius: constants_1.theme.border.radius.normal - 1,
        borderBottomRightRadius: constants_1.theme.border.radius.normal - 1,
    },
    '&:not(:first-of-type) > *': {
        borderTop: `${constants_1.theme.border.width.thin}px solid ${constants_1.Color.GREY}`,
    },
}));
const ContactRequest = ({ contactRequest, onClick, }) => {
    const { contactRequestOpenedAt, createdAt, senderName, text } = contactRequest;
    const t = (0, translate_1.useTranslations)();
    return ((0, jsx_runtime_1.jsx)(ContactRequestElement, { isOpened: !!contactRequestOpenedAt, onClick: () => onClick(contactRequest), children: (0, jsx_runtime_1.jsxs)(elements_1.Flex, { col: true, gap: 1.5, styles: {
                fontSize: constants_1.theme.font.size[6.5],
                fontWeight: contactRequestOpenedAt
                    ? constants_1.theme.font.weight.book
                    : constants_1.theme.font.weight.bold,
                py: 3,
            }, children: [(0, jsx_runtime_1.jsxs)(elements_1.Flex, { justify: "between", children: [(0, jsx_runtime_1.jsx)(elements_1.Text, { color: contactRequestOpenedAt ? constants_1.Color.DARK_GREY : constants_1.Color.BLACK, children: senderName }), (0, jsx_runtime_1.jsx)(elements_1.Text, { color: constants_1.Color.DARK_GREY, textAlign: "right", children: t.$date.unix(createdAt).fromNow() })] }), (0, jsx_runtime_1.jsxs)(elements_1.Text, { color: contactRequestOpenedAt ? constants_1.Color.DARK_GREY : constants_1.Color.BLACK, lineHeight: 1.4, noWrap: true, children: [(0, jsx_runtime_1.jsxs)(elements_1.Text, { bold: true, children: [senderName, ":"] }), " ", text] })] }) }));
};
exports.ContactRequest = ContactRequest;
